import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage bg-grid relative py-12 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-292" data-mp="2sk43xcq97k7c">
      <div className="absolute inset-x-0 top-0 h-2 hazard-stripe" aria-hidden="true" data-id="element-293" data-mp="36c28da90srx6" />
      <div className="absolute inset-x-0 bottom-0 h-2 hazard-stripe" aria-hidden="true" data-id="element-294" data-mp="31hxxwh0jq1rc" />
      <div className="mx-auto max-w-3xl px-4" data-id="element-295" data-mp="3g6keem1wszk5">
        <p className="font-mono text-[11px] font-bold uppercase tracking-[.2em] text-gold" data-id="element-296" data-mp="3b9aq59q9atxw">Precio de lanzamiento · cierra en</p>
        <Countdown light className="mt-5 scale-110" data-id="element-297" data-mp="3p7s9ywd1jmaj" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-298" data-mp="3p6h6yyrf6ikh">Después sube. No vuelve al precio de lanzamiento.</p>
        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-md border border-gold/40 p-4 text-sm" data-id="element-299" data-mp="1uusqgs5ji7xz">
          <p className="font-bold" data-id="element-300" data-mp="1qtgvs87t6wix">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-gold" data-id="element-301" data-mp="1qu8pfdhuik6k" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-sm bg-black/50" data-id="element-302" data-mp="2xshm9jnieqdk">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full bg-gold" data-id="element-303" data-mp="2xqemw90gvkw6" />
          </div>
          <p className="mt-1 text-right font-mono text-xs text-mutedDark" data-id="element-304" data-mp="3cjq9xn7uq1o2">71% tomados</p>
        </div>
      </div>
    </section>;
}